/* eslint-disable */
export const SearchCriteria = {

    hiddenKeys: [
        "queryType",
        "editView",
    ],

    hiddenPageKeys: [
        "limit",
        "offset",
    ],

    updateUrl(context) {
        const urlParam = {};
        Object.entries(context.searchCriteria).forEach(([key, value]) => {
            if (key !== "page") {
                if (!this.hiddenKeys.includes(key) && value && value !== false) {
                    urlParam[key] = "" + value;
                }
            } else {
                Object.entries(value).forEach(([pageKey, pageValue]) => {
                    if (pageValue && !this.hiddenPageKeys.includes(pageKey)) {
                        urlParam["page" + pageKey] = "" + pageValue;
                    }
                });
            }
        });

        if (JSON.stringify(urlParam) !== JSON.stringify(context.$route.query)) {
            context.$router.push({name: context.$route.name, query: urlParam});
        }
    },

    loadCriteria(context) {
        Object.entries(context.$route.query).forEach(([key, value]) => {
            if (value) {
                if (key.startsWith("page")) {
                    context.searchCriteria.page[key.substr(4)] = isNaN(value) ? value : parseInt(value, 10);
                } else {
                    if (value === "false") {
                        context.searchCriteria[key] = false;
                    } else if (value === "true") {
                        context.searchCriteria[key] = true;
                    } else {
                        context.searchCriteria[key] = isNaN(value) ? value : parseInt(value, 10);
                    }
                }
            }
        });
    },

};
